module.exports = __webpack_public_path__ + "static/img/newanli-11.4b8352b7.jpg";